import { LocalizationProvider } from '@mui/x-date-pickers';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// or for dayjs
import { DatePicker } from '@mui/x-date-pickers';

import { Controller } from "react-hook-form";
import React from "react";

export const InputDateField = ({ control, name, ...props }: any) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Controller
                control={control}
                name={name}
                render={({ field }) => (
                    <DatePicker
                        {...field}
                        {...props}
                    />
                )}
            />
        </LocalizationProvider>
    );
}

